// extracted by mini-css-extract-plugin
module.exports = {"procedureHeader":"ProcedureHeader_procedureHeader__swXuS","procedureTitle":"ProcedureHeader_procedureTitle__v86SD","procedureSubtitle":"ProcedureHeader_procedureSubtitle__POae4"};